// assets/product-tabs.js
// Small reusable tabs component: labelled buttons + one rich-text panel per
// child block. Modeled on the tablist toggle pattern already proven in
// blocks/stamp-customizer.liquid (role="tablist" + on:click="/method").
import { Component } from '@theme/component';

class ProductTabsComponent extends Component {
  /** @param {Event} event */
  handleTabClick(event) {
    const btn = /** @type {HTMLElement} */ (event.target)?.closest?.('[data-tab-index]');
    if (!btn) return;
    const index = btn.dataset.tabIndex;

    (this.refs.tabButtons ?? []).forEach((b) => {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    (this.refs.tabPanels ?? []).forEach((p) => {
      p.hidden = p.dataset.tabIndex !== index;
    });
  }
}

if (!customElements.get('product-tabs-component')) {
  customElements.define('product-tabs-component', ProductTabsComponent);
}
